import { useSelector } from "react-redux";
import { Selectors as RegisterSelectors } from "@/store/userRegister/selectors";
const ns = "login:";
export const useHeader = ({ t: baseT, mode, enabled }) => {
  const regStep = useSelector(RegisterSelectors.getStep);
  if (!enabled) return null;
  const t = (key) => baseT(key, { defaultValue: null });
  if (mode === "restorePassword") {
    return t(ns + "restore_head");
  } else if (mode === "auth") {
    return t(ns + "auth_head");
  } else {
    if (regStep === 1) return t(ns + "reg_head");
    return t(`${ns}reg_head_${regStep}`);
  }
};
